import { SET_IS_NEW_RECORD } from '../actionTypes';
import { configurationDocumentsActions } from '../reducer';

export default (value) =>
    configurationDocumentsActions[SET_IS_NEW_RECORD](value);
